<template>
  <div class="-app">
    <div class="-header">
      <div class="-nav">
        <router-link to="/locations" class="-nav-item" style="text-decoration: none;">
          <h1>Consumerview</h1>
        </router-link>

        <div v-if="locations" class="-nav-item">
          <router-link to="/locations">Location</router-link>
          <div class="-nav-dropdown">
            <div v-for="location in locations" :key="location.id" class="-nav-item">
              <router-link :to="`/locations/${location.id}`">{{ location.name }}</router-link>
            </div>
          </div>
        </div>
        <div v-if="user" class="-nav-item">
          <div v-if="user.admin">
            <router-link to="/users">Users</router-link>
          </div>
        </div>

        <div class="grow"></div>

        <div v-if="user" class="-nav-item">
          <div v-if="user.user_image">
            <img class="-profile-picture" :src="user.user_image" alt="Profile picture">
          </div>

          <div v-else>
            <div class="-profile-picture-empty"></div>
          </div>

          <div class="-nav-dropdown align-right">
            <div class="-nav-item">
              <router-link :to="'/profile-page'">Profile</router-link>
            </div>
            <div class="-nav-item" @click="logout">
              <a>Logout</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="-main">
      <div class="-container">
        <router-view />
      </div>
    </div>
    <footer class="-footer"></footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  data: () => ({}),
  computed: {
    user() {
      return this.$store.state.user
    },
    locations() {
      return this.$store.state.locations
    },
  },

  watch: {},

  methods: {
    logout() {
      this.$store.dispatch('logout')
    },
  },
}
</script>

<style lang="scss">
html {
  background-color: #ffffff;
  background-image: url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ead6ca' fill-opacity='0.5' fill-rule='evenodd'%3E%3Cpath d='M0 40L40 0H20L0 20M40 40V20L20 40'/%3E%3C/g%3E%3C/svg%3E");
}

.-header {
  display: flex;
  width: 100%;
  background-color: #704730;
  height: 50px;
  padding: 0 1rem;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.2);
  position: fixed;
  top: 0;
  z-index: 10;
}

.-nav {
  align-self: stretch;
  display: flex;
  flex-grow: 1;
  margin-left: 1rem;
  li {
    display: inline-block;
    margin-top: 10px;
  }
  .-nav-item {
    align-self: stretch;
    display: flex;
    align-items: center;
    background: #704730;
    white-space: nowrap;
    line-height: 100%;
    color: white;
    font-size: 1.25rem;
    font-weight: bold;
    position: relative;

    h1 {
      color: white;
      font-size: 180%;
      padding: 8px;
      margin-top: 8px;
    }
    a {
      vertical-align: middle;
      color: inherit;
      text-decoration: none;
      padding: 20px;
      width: 100%;
    }
    .-nav-dropdown {
      display: none;
    }
    &:hover {
      cursor: pointer;
      background-color: #8C6B59;
      .-nav-dropdown {
        display: block;
        position: absolute;
        top: 100%;
        left: 0;
        &.align-right {
          right: 0;
          left: auto;
        }
      }
    }
    &.li {
      background-color: #8C6B59;
    }
  }
  .-profile-picture {
    height: 42px;
    width: 42px;
    border-radius: 100%;
  }
}

.-profile-picture-empty {
  height: 42px;
  width: 42px;
  border-radius: 100%;
  background-color: #ffffff;
}

.-main {
  display: flex;
  flex-grow: 0;
  justify-content: center;
  padding: 10px;
  margin-top: 100px;
}

.-container {
  max-width: 100%;
}

.-footer {
  margin-top: auto;
  margin-bottom: 5vh;
}
</style>
